import axios from 'axios'

const api = axios.create({
  baseURL: 'https://buencomienzo2025.kagencia.com/api',
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

export default api
